/**
 * 校验特殊字符
 */
const checkSpecialCharacter = (rule, value, callback) => {
   //const reg = new RegExp("[`~!%@#$^&*()=|{}':;',\\[\\]<>《》/?~！@#￥（——）……&*|{}【】‘；：”“'\"。，、？¥￥]");
   const reg = /^[\u4E00-\u9FA5A-Za-z0-9]*$/; // 中文，字母和数字
   if (!reg.test(value)) {
      return callback("不能输入特殊字符");
   } else {
      return callback();
   }
};
//公司名称校验
const checkSpecialCharacterCompany = (rule, value, callback) => {
   const reg = /^[\u4E00-\u9FA5A-Za-z0-9()（）]*$/; // 中文，字母和数字, ()（）
   if (!reg.test(value)) {
      return callback("不能输入特殊字符");
   } else {
      return callback();
   }
};
//填开地址校验
const checkSpecialCharacterAddress = (rule, value, callback) => {
   const reg = /^[\u4E00-\u9FA5A-Za-z0-9()（）#——\-\s]*$/;// 中文，字母和数字,空格 # - ()（）
   if (!reg.test(value)) {
      return callback("不能输入特殊字符");
   } else {
      return callback();
   }
};
//正常地址校验，无空格
const checkSpecialCharacterNormalAddress = (rule, value, callback) => {
   const reg = /^[\u4E00-\u9FA5A-Za-z0-9()（）#——\-]*$/;// 中文，字母和数字# - ()（）
   if (!reg.test(value)) {
      return callback("不能输入特殊字符");
   } else {
      return callback();
   }
};
const checkSpecialProductName = (rule, value, callback) => {
   const reg = /^[\u4E00-\u9FA5A-Za-z0-9()（）#——\-、\s%【】{}]*$/;// 中文，字母和数字# - ()（）、空格
   if (!reg.test(value)) {
      return callback("不能输入特殊字符");
   } else {
      return callback();
   }
};
//备注，描述校验
const checkSpecialCharacterDsp = (rule, value, callback) => {
   const reg = /^[\u4E00-\u9FA5A-Za-z0-9,\.，。：:;；\s()（）{}\[\]【】<>《》\/！!、“”'"‘’]*$/; // 中文，字母和数字空格及,. ，。：:;等；
   if (!reg.test(value)) {
      return callback("不能输入特殊字符");
   } else {
      return callback();
   }
};
//优惠政策名称
const checkSpecialCharacterPolicy = (rule, value, callback) => {
   const reg = /^[\u4E00-\u9FA5A-Za-z0-9%]*$/; // 中文，字母和数字,%
   if (!reg.test(value)) {
      return callback("不能输入特殊字符");
   } else {
      return callback();
   }
};
const checkEmail = (rule, value, callback) => {
   const reg = /^([a-zA-Z0-9_\.\-])+@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,6})$/;
   if (value && !reg.test(value)) {
      return callback("请填写正确格式的电子邮箱");
   } else {
      return callback();
   }
};
const checkPhone = (rule, value, callback) => {
   const reg = /^(0\d{2,3}-\d{7,8})$|^(0|86|17951)?(13[0-9]|15[0-9]|17[0-9]|18[0-9]|14[57])[0-9]{8}$/;
   if (value && !reg.test(value)) {
      return callback("请填写正确格式的电话号码！");
   } else {
      return callback();
   }
};
const checkBankId = (rule, value, callback) => {
   const reg = /^[0-9]{12}[0-9]{0,12}$/;
   if (value && !reg.test(value)) {
      return callback("账号12~24位数字组成");
   } else {
      return callback();
   }
};
const checkLetterCap = (rule, value, callback) => {
   const regTest = /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/
   if(value && !regTest.test(value)){
      return callback('税号由15,17,18,20位大写字母和数字组成');
   }else {
      return callback();
   }
}
const checkLetterNumber = (rule, value, callback) => {
   const regTest = /^[0-9a-zA-Z]+$/
   if(value && !regTest.test(value)){
      return callback('单据编号由字母和数字组成');
   }else {
      return callback();
   }
}
const checkLetterPureNumber = (rule, value, callback) => {
   const regTest = /^[0-9]+$/
   if(value && !regTest.test(value)){
      return callback('不能输入特殊字符');
   }else {
      return callback();
   }
}
const checkSpecialCharacterPeople = (rule, value, callback) => {
   const reg = /^[\u4E00-\u9FA5A-Za-z0-9]*$/; // 中文，字母和数字
   if (!reg.test(value)) {
      return callback("不能输入特殊字符");
   } else {
      return callback();
   }
};
const checkPort = (rule, value, callback) => {
   const reg = /^[0-9]{1,5}$/;
   if (!reg.test(value)) {
      return callback("端口号必须为正整数且不超过5位");
   } else {
      const val = parseInt(value, 10);
      if(val < 10000) {
         return callback("端口号不能小于10000");
      }else if(val > 65535) {
         return callback('端口号不能大于65535');
      }else {
         const ports = [10067,10167,11000,11223,12076,12223,12345,12346,12361,
            13223,16969,17027,19132,19191,20000,20001,20034,
            20432,21554,22222,23456,25565,26274,27017,27374,30003,30100,30303,
            30999,31337,31338,31339,31666,31789,33333,34324,40412,40421,40422,
            40423,40426,43210,44445,47262,47878,50505,50766,53001,54321,61466,
            64101,65000];
         if(ports.indexOf(val) !== -1) {
            return callback('端口号为高危端口号，请重新输入!');
         }else {
            return callback();
         }
      }
   }
};
const checkLength = (max = 50) => {
   return function (rule: any, value: any, callback: any, source?: any, options?: any) {
      const realLength = getLength(value);
      return realLength <= max ? callback() : callback(`输入长度应少于${max}个字符！`);
   }
};

//获取文本字节长度
const getLength = (str: string) => {
   //先把中文替换成两个字节的英文，在计算长度
   return str ? str.replace(/[\u0391-\uFFE5]/g, "aa").length : 0;
}

export default {
   checkSpecialCharacter,
   checkSpecialCharacterCompany,
   checkSpecialCharacterAddress,
   checkSpecialCharacterNormalAddress,
   checkSpecialCharacterDsp,
   checkSpecialCharacterPolicy,
   checkEmail,
   checkPhone,
   checkBankId,
   checkLength,
   getLength,
   checkPort,
   checkLetterCap,
   checkLetterNumber,
   checkSpecialCharacterPeople,
   checkLetterPureNumber,
   checkSpecialProductName
};



// WEBPACK FOOTER //
// ./src/utils/Doc/Check.ts